export default "__VITE_ASSET__wHE_k6yK__"